import "swiper/css";
import "swiper/css/navigation";
import React, { useRef, useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
import Warfare from "../../../images/GameSwiper/Warfare.webp";
import AssasingCreed from "../../../images/GameSwiper/AssasingCreed.webp";
import SpiderMan from "../../../images/GameSwiper/Spider-man2.webp";
import UFC from "../../../images/GameSwiper/UFC.webp";
import prevBtn from "./Icon Frame (1).png";
import nextBtn from "./Icon Frame (2).png";
import acs from "../../../images/GameSwiper/acs.webp";
import bmw from "../../../images/GameSwiper/bmw.webp";
import cd_6 from "../../../images/GameSwiper/cd_6.webp";
import fc_25 from "../../../images/GameSwiper/fc_25.webp";
import kcd_II from "../../../images/GameSwiper/kcd_II.webp";
import mk1 from "../../../images/GameSwiper/mk1.webp";
import sf from "../../../images/GameSwiper/sf.webp";

const GameSwiper = ({ quantity }) => {
    const prevRef = useRef(null);
    const nextRef = useRef(null);
    const swiperRef = useRef(null);

    const games = [
        { title: "Assassin’s Creed Shadows", image: acs },
        { title: "Black Myth: Wukong", image: bmw },
        { title: "Call of Duty: Black Ops 6", image: cd_6 },
        { title: "EA Sports FC 25", image: fc_25 },
        { title: "Kingdom Come: Deliverance II", image: kcd_II },
        { title: "Mortal Kombat 1", image: mk1 },
        { title: "Split Fiction", image: sf },
    ];

    useEffect(() => {
        if (swiperRef.current) {
            swiperRef.current.params.navigation.prevEl = prevRef.current;
            swiperRef.current.params.navigation.nextEl = nextRef.current;
            swiperRef.current.navigation.init();
            swiperRef.current.navigation.update();
        }
    }, []);

    return (
        <div className="game-swiper">
            <Swiper
                modules={[Navigation, Autoplay]}
                spaceBetween={10}
                slidesPerView={quantity}
                loop={true}
                autoplay={{
                    delay:2000,
                    disableOnInteraction: false,
                }}
                onSwiper={(swiper) => (swiperRef.current = swiper)}
                breakpoints={{
                    0: { slidesPerView: 1 },
                    560: { slidesPerView: 1 },
                    680: { slidesPerView: 2 },
                    950: { slidesPerView: 3 },
                    1284: { slidesPerView: 4 },
                }}
            >
                {games.map((game, index) => (
                    <SwiperSlide key={index}>
                        <div className="game-card">
                            <img src={game.image} alt={game.title} />
                            <h3>{game.title}</h3>
                        </div>
                    </SwiperSlide>
                ))}
            </Swiper>
            <button ref={prevRef} className="custom-prev">
                <img className='arrow-btn' src={prevBtn} alt="Previous" />
            </button>
            <button ref={nextRef} className="custom-next">
                <img className='arrow-btn' src={nextBtn} alt="Next" />
            </button>
        </div>
    );
};

export default GameSwiper;
